// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Grid from '@mui/material/Grid2';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 PRO React examples
import PageLayout from 'components/LayoutContainers/PageLayout';

// Authentication pages components
import Footer from 'views/Welcome/components/Footer';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import themeDark from 'assets/theme-dark';

import logger from 'utils/logger';
import { zIndexValues } from 'utils/styles';

const log = logger.createLogger('BasicLayout');
function BasicLayout({ image, loginMode, children }) {
  return (
    <ThemeProvider theme={themeDark}>
      <CssBaseline />
      <PageLayout>
        <MDBox
          id="BasicLayoutBackgroundBox"
          position="absolute"
          width="100%"
          minHeight="100vh"
          sx={{
            backgroundImage: ({
              functions: { linearGradient, rgba },
              palette: { gradients },
            }) =>
              image &&
              `${linearGradient(
                rgba(gradients.dark.main, 0.0),
                rgba(gradients.dark.state, 0.0)
              )}, url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: zIndexValues.bottom,
          }}
        />

        <MDBox
          id="BasicLayoutChildrenContainerBox"
          px={0}
          py={'30vh'}
          width="100%"
          minHeight="100vh"
          mx="auto"
          sx={{
            overflowY: 'auto', // Add this to enable scrolling
          }}>
          <Grid
            id="BasicLayoutChildrenGridOuter"
            container
            spacing={1}
            justifyContent="center"
            alignItems="center"
            height="100%">
            <Grid id="BasicLayoutChildrenGridInner" size={7}>
              {children}
            </Grid>
          </Grid>
        </MDBox>
        <Footer id="Footer" loginMode={loginMode} light />
      </PageLayout>
    </ThemeProvider>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  loginMode: PropTypes.number.isRequired,
  children: PropTypes.node,
};

export default BasicLayout;
